import React, { useContext, useEffect } from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'
import {
  FileDetailBaseLayout,
  MediaLibraryBaseLayout,
} from '../../layouts/MediaLibrary'
import { CustomMetadataProvider } from '../../providers/CustomMetadataProvider'
import { PublicLinksInfoContext } from '../../providers/PublicLinksInfoProvider'
import DownloadsPage from '../Downloads'
import { MediaLibraryPage, GenerateImagesPage } from '.'

const MediaLibraryRouter = (): React.ReactElement => {
  const { path } = useRouteMatch()
  const { isPublicLink } = useContext(PublicLinksInfoContext)

  useEffect(() => {
    let timeoutId: NodeJS.Timeout | null = null

    function waitForIntercom(): void {
      if (window.Intercom?.booted) {
        try {
          window.Intercom('hide')
          window.Intercom('update', {
            hide_default_launcher: true,
          })
        } catch (e) {
          //do nothing
        }
        return
      }
      timeoutId = setTimeout(waitForIntercom, 100)
    }

    waitForIntercom()

    return () => {
      try {
        window.Intercom('update', {
          hide_default_launcher: false,
        })
      } catch (e) {
        //do nothing
      }

      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [])

  return (
    <CustomMetadataProvider>
      <Switch>
        {!isPublicLink ? (
          <Route path={`${path}/detail/:fileId/:versionId`} exact>
            <MediaLibraryBaseLayout>
              <FileDetailBaseLayout />
            </MediaLibraryBaseLayout>
          </Route>
        ) : null}

        <Route path={`${path}/detail/:fileId`} exact>
          <MediaLibraryBaseLayout>
            <FileDetailBaseLayout />
          </MediaLibraryBaseLayout>
        </Route>

        <Route path={`${path}/generate-images`} exact>
         <MediaLibraryBaseLayout>
          <GenerateImagesPage />
          </MediaLibraryBaseLayout>
        </Route>

        <Route path={`${path}/downloads`} exact>
          <DownloadsPage />
        </Route>

        <Route path={`${path}/:folderPathBase64?`} exact>
          <MediaLibraryBaseLayout>
            <MediaLibraryPage />
          </MediaLibraryBaseLayout>
        </Route>
      </Switch>
    </CustomMetadataProvider>
  )
}

export default MediaLibraryRouter
